/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ReportMetadataDto {
  id: number;
  requestTime: string;
  endTimestamp: string;
  reportType: ReportMetadataDto.ReportTypeEnum;
  status: ReportMetadataDto.StatusEnum;
}
export namespace ReportMetadataDto {
  export const ReportTypeEnum = {
    ClientOrdersmichiganTransfersclientBalanceCsvclientBalancePdfcomprehensivePdf:
      'CLIENT_ORDERS,MICHIGAN_TRANSFERS,CLIENT_BALANCE_CSV,CLIENT_BALANCE_PDF,COMPREHENSIVE_PDF',
  } as const;
  export type ReportTypeEnum = (typeof ReportTypeEnum)[keyof typeof ReportTypeEnum];
  export const StatusEnum = {
    Queued: 'QUEUED',
    InProgress: 'IN_PROGRESS',
    Done: 'DONE',
    Failed: 'FAILED',
    Cancelling: 'CANCELLING',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
